import * as React from 'react';
import type { CarouselApi } from '@/components/ui/carousel';

/** True when the carousel has multiple items and more than one scroll snap (nothing to paginate otherwise). */
export function useCarouselNeedsNavigation(api: CarouselApi | undefined, itemCount: number) {
  const [needsNavigation, setNeedsNavigation] = React.useState(itemCount > 1);

  React.useEffect(() => {
    if (itemCount <= 1) {
      setNeedsNavigation(false);
      return;
    }
    if (!api) return;

    const update = () => {
      setNeedsNavigation(api.scrollSnapList().length > 1);
    };

    update();
    api.on('select', update);
    api.on('reInit', update);
    api.on('resize', update);

    return () => {
      api.off('select', update);
      api.off('reInit', update);
      api.off('resize', update);
    };
  }, [api, itemCount]);

  return needsNavigation;
}
